import NoAuthLayout from './NoAuthLayout';

export {
  StyledField as StyledSubmissionField,
  StyledAnchor as StyledSubmissionAnchor,
  StyledFormInput as StyledSubmissionInput,
} from './StyledNoAuthComponent';
export default NoAuthLayout;
